import { useErrorBoundary } from 'react-error-boundary';

import { CenterFlex, VFlex } from '@/components/base';
import Button from '@/components/Button/Button';
import Typo from '@/components/Typography/Typo';

type ErrorDisplayProps = {
  height?: string;
};

const ErrorDisplay = (props: ErrorDisplayProps) => {
  const { resetBoundary } = useErrorBoundary();
  const onClickRetry = () => {
    resetBoundary();
  };

  return (
    <CenterFlex height={props.height || '100%'}>
      <VFlex g={8}>
        <Typo weight="m" type="label3">
          Error! try again
        </Typo>

        <Button variant="primary" sizeType="m" rounded onClick={onClickRetry}>
          <Typo type="label3">Try again</Typo>
        </Button>
      </VFlex>
    </CenterFlex>
  );
};

export default ErrorDisplay;
